
export class Pet {
    id;         // the pet's id
    shelterID; // Shelter's ID
    name;
    species; // string =. cat, dog, other
    breed; // string => dogBreed or catBreed
    disposition; // string
    description;
    availability; // string
    age;
    petImgUrl; //= ["link","link"];
}

//export default Pet;